
<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: Object,
    chartdata2: Array,
    options: Array,
    color: Array,
    color2: String,
  },
  data() {
    return {
      gradient: null,
      gradient2: null,

      gradientColor: [],
      data: [],
    };
  },
  mounted() {
    console.log(this.color);
    for (let i = 0; i < this.color.length; i++) {
      const el = this.color[i];
      this.gradientColor.push(
        this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 190)
      );
      let gradientStep1 = el;
      let gradientStep2 = el + "7a";
      let gradientStep3 = el + "00";

      this.gradientColor[i].addColorStop(0, gradientStep1);
      this.gradientColor[i].addColorStop(0.5, gradientStep2);
      this.gradientColor[i].addColorStop(1, gradientStep3);
    }
    console.log(this.chartdata);
    this.data = [];
    for (let i = 0; i < this.chartdata.value.length; i++) {
      const el = this.chartdata.value[i];
      this.data.push({
        label: this.chartdata.tooltip_label[i],
        // backgroundColor: this.color,
        // data: this.chartdata,
        data: el,
        borderWidth: 3,
        borderColor: this.color[i],
        backgroundColor: this.gradientColor[i],
        pointBorderWidth: 1,
      });
    }
    console.log("multichart", this.data);

    // this.gradient = this.$refs.canvas
    //   .getContext("2d")
    //   .createLinearGradient(0, 0, 0, 200);
    // let gradientStep1 = this.color;
    // let gradientStep2 = this.color + "7a";
    // let gradientStep3 = this.color + "00";

    // this.gradient.addColorStop(0, gradientStep1);
    // this.gradient.addColorStop(0.5, gradientStep2);
    // this.gradient.addColorStop(1, gradientStep3);

    // this.gradient2 = this.$refs.canvas
    //   .getContext("2d")
    //   .createLinearGradient(0, 0, 0, 200);
    // gradientStep1 = this.color2;
    // gradientStep2 = this.color2 + "7a";

    // this.gradient2.addColorStop(0, gradientStep1);
    // this.gradient2.addColorStop(0.5, gradientStep2);
    // this.gradient2.addColorStop(1, "rgba(255, 255, 255, 1)");

    this.renderChart(
      {
        // labels: this.options,
        labels: this.chartdata.labels,
        datasets: this.data,
        // function () {
        //   let data = [];
        //   for (let i = 0; i <  2; i++) {
        //     // const element = this.chartdata[i];
        //     data.push({
        //       label: "Temperature ( °C )",
        //       // backgroundColor: this.color,
        //       // data: this.chartdata,
        //       data: [29, 49, 25, 36, 34, 30, 36, 40],
        //       borderWidth: 3,
        //       borderColor: this.color[i],
        //       backgroundColor: this.gradientColor[i],
        //       pointBorderWidth: 1,
        //     });
        //   }
        //   console.log('multichart',data);
        //   return data;
        // },
        // [
        //   {
        //     label: "Temperature ( °C )",
        //     // backgroundColor: this.color,
        //     // data: this.chartdata,
        //     data: [29, 49, 25, 36, 34, 30, 36, 40],
        //     borderWidth: 3,
        //     borderColor: this.color[0],
        //     backgroundColor: this.gradientColor[0],
        //     pointBorderWidth: 1,
        //   },
        //   // {
        //   //   label: "Humidity ( % )",
        //   //   // backgroundColor: this.color,
        //   //   // data: this.chartdata,
        //   //   data: [41, 44, 35, 36, 44, 39, 46, 45],
        //   //   borderWidth: 3,
        //   //   borderColor: this.color2,
        //   //   backgroundColor: this.gradient2,
        //   //   pointBorderWidth: 1,
        //   // },
        // ],
      },
      {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
        title: {
          display: true,
        },
        position:'bottom'
      },
        scales: {
          //   yAxes: [
          //     {
          //       ticks: {

          //         max: 100,

          //       },
          //     },
          //   ],
          xAxis: {
            // The axis for this scale is determined from the first letter of the id as `'x'`
            // It is recommended to specify `position` and / or `axis` explicitly.
            type: "time",
          },
        },
      }
    );
  },
  computed: {
    chartData: function () {
      console.log("chartData");

      return this.data;
    },
  },
};
</script>

<style scoped>
.cardBorder {
  border-radius: 20px;
}
.cardBordercolor {
  border-radius: 35px;
  border-style: solid;
  border-color: #6fda79;
}
.stack {
  position: relative;
  top: 15px;
  right: 110px;
}
</style>